/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DurationInMonthsQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("DurationInMonthsQueryOperator");
    }

    getFixupPrototypeFunction() { return DurationInMonthsQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<DurationInMonthsQueryOperator>): DurationInMonthsQueryOperator {
        let obj = Object.assign(new DurationInMonthsQueryOperator(), model);
        DurationInMonthsQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DurationInMonthsQueryOperator>): DurationInMonthsQueryOperator {
        if (!model) return null;
        return DurationInMonthsQueryOperator.newInstance(<DurationInMonthsQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DurationInMonthsQueryOperator) {
        if (!obj) return;

        models.DurationInMonthsQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DurationInMonthsQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DurationInMonthsQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.duration === undefined) {
            this.duration = 0;
        }
    }

    /**
     * Time Duration (in months) to filter the data. The allowed values are 2, 3, 6, and 12 months.
     */
    duration: number;

}
